module.exports = __webpack_public_path__ + "img/custom-item3-3.27bf1f5.png";